import React from 'react'
import parse from 'html-react-parser'

import Info from 'shared/Info/Info'

interface Datas {
  datas: {
    flamelinkAboutContent: {
      title: string
      description: string
    }
  }
}

const s = {
  container: `w-full h-fit-content text-black`,
  content: `mb-20 last:mb-0`,

  group: `w-fit-content h-fit-content`,
  line: `w-full h-1.5 mt-0 mb-16 bg-impred`,

  title: `mb-0`,
  description: `w-4/5 -mt-4 text-base leading-loose mdx:w-full`,

  subtitle: `mb-0 text-3xl`,
}

const Content = ({ datas }: Datas) => {
  const { title, description } = datas.flamelinkAboutContent

  return (
    <div className={s.container}>
      <div className={s.content}>
        <div className={s.group}>
          <h2 className={s.title}>{title}</h2>
          <div className={s.line} />
        </div>

        <div className={s.description}>{parse(description)}</div>
      </div>

      <div className={s.content}>
        <div className={s.group}>
          <h3 className={s.subtitle}>Info</h3>
          <div className={s.line} />
        </div>
        <Info />
      </div>
    </div>
  )
}

export default Content
